import { buildPaidMessage } from "../terminal-payment/terminalPaymentMessages";
import { MbwayRequest } from "./mbwayPaymentApi";

const DEFAULT_FAILURE_MESSAGE = "Não foi possível enviar o pedido MB WAY. Tente novamente ou escolha outro método.";

export const ORDER_PAID_ELSEWHERE_REASON = "order_paid_elsewhere";

const FAILURE_REASON_TEXTS: Record<string, string> = {
    declined_by_bank: "O pedido MB WAY foi recusado.",
    order_paid_elsewhere: "Esta compra já está paga. Não aceite o pedido MB WAY que ainda possa aparecer no telemóvel.",
    mbway_number_rejected: "Não foi possível enviar o pedido para este número. Confirme o número ou escolha outro método de pagamento.",
    mbway_config_error: "O pagamento por MB WAY não está configurado. Contacte o apoio ao cliente.",
};

const buildPendingMessage = (request: MbwayRequest) => {
    const pendingMessage = request.request_confirmed
        ? `Pedido enviado para ${request.phone_masked}. À espera que o cliente aceite na app MB WAY…`
        : `A confirmar o envio do pedido para ${request.phone_masked}…`;
    return pendingMessage;
};

const buildFailureMessage = (failureReason: string | null) => {
    const failureMessage = (failureReason && FAILURE_REASON_TEXTS[failureReason]) || DEFAULT_FAILURE_MESSAGE;
    return failureMessage;
};

export const buildMbwayRequestMessage = (request: MbwayRequest) => {
    const messagesByStatus: Record<MbwayRequest["status"], () => string> = {
        pending: () => buildPendingMessage(request),
        paid: () => buildPaidMessage(request.amount, request.recording_status),
        refused: () => "O pedido foi recusado na app MB WAY.",
        expired: () => "O pedido MB WAY expirou sem ser aceite.",
        declined: () => "O pedido MB WAY foi recusado.",
        replaced: () => "Pedido anulado. Pode enviar um novo pedido ou escolher outro método.",
        failed: () => buildFailureMessage(request.failure_reason),
    };
    const requestMessage = messagesByStatus[request.status]();
    return requestMessage;
};
